import cn from 'classnames';
import iArrow from '../../../assets/images/arrow.svg';
import iBsc from '../../../assets/images/bsc.svg';
import {TProjectResponse} from '../../../redux/types';
import './invest-hint.sass';

type TProps = {
  project: TProjectResponse;
  tokenIcon?: string;
};

function InvestHint({project, tokenIcon}: TProps) {
  return (
    <div className="invest-hint">
      <div className="invest-hint__header">
        <div className="invest-hint__title">{project.info}</div>
        <img className={cn('invest-hint__arrow')} src={iArrow} />
      </div>
      <div className="invest-hint__body">
        <div className="invest-hint__item">
          <div className="invest-hint__key">Network</div>
          <div className="invest-hint__value">
            <img src={iBsc} />
            {project.tgeNetwork}
          </div>
        </div>
        <div className="invest-hint__item">
          <div className="invest-hint__key">Token</div>
          <div className="invest-hint__value">
            <img src={tokenIcon} />
            {project.tgeToken}
          </div>
        </div>
        <div className="invest-hint__item">
          <div className="invest-hint__key">TGE Date</div>
          <div className="invest-hint__value">
            {Number(project.tgeDate) ? new Date(Number(project.tgeDate) * 1000).toLocaleDateString() : 'TBA'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvestHint;
